import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { RHeader, RPage, RViewer } from '../../../../components/PdfRender';
import { useCompany } from '../../../../hooks/company';
import { IFinancial } from '../../../interfaces';
import * as S from './styles';
import { currency } from '../../../utils/functions';
import { formatDate } from '../../../utils/format-date';

interface IAccountsPayableReportProps {
  financials: IFinancial[];
}

export const AccountsPayableReport: React.FC<IAccountsPayableReportProps> = ({
  financials,
}) => {
  const { company } = useCompany();
  const total = financials.reduce((acc, curr) => acc + Number(curr.value), 0);

  return (
    <RViewer>
      <RPage size={'A4'}>
        <View style={S.styles.container}>
          <RHeader company={company} />
          <Text style={S.styles.title}>Relatório de Contas a Pagar</Text>

          <View style={S.styles.table}>
            <View style={[S.styles.tableRow, S.styles.tableHeader]}>
              <View style={[S.styles.tableCol, S.styles.colDate]}>
                <Text>Vencimento</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colClient]}>
                <Text>Fornecedor</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colDesc]}>
                <Text>Descrição</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colValue]}>
                <Text>Valor</Text>
              </View>
            </View>

            {financials.map((item, index) => (
              <View key={index} style={S.styles.tableRow}>
                <View style={[S.styles.tableCol, S.styles.colDate]}>
                  <Text>{formatDate(item.due_date)}</Text>
                </View>
                <View style={[S.styles.tableCol, S.styles.colClient]}>
                  <Text>{item.client_name}</Text>
                </View>
                <View style={[S.styles.tableCol, S.styles.colDesc]}>
                  <Text>{item.description || '-'}</Text>
                </View>
                <View style={[S.styles.tableCol, S.styles.colValue]}>
                  <Text>{currency(item.value)}</Text>
                </View>
              </View>
            ))}
          </View>

          <View style={S.styles.totalContainer}>
            <Text style={S.styles.totalText}>
              Total a Pagar: {currency(total)}
            </Text>
          </View>
        </View>
      </RPage>
    </RViewer>
  );
};
